import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { DropDownIcon } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  styles?: string;
  onClick?: () => void;
  label?: string;
  data?: string[];
  setDropDownSelection?: Dispatch<
    SetStateAction<null | string | { [key: number]: string }>
  >;
  placeholder?: string;
  defaultSelected?: string | null | { [key: number]: string };
  isDisabled?: boolean;
  dataTrackingId?: string;
}

export const DropDown = ({
  styles,
  onClick,
  label,
  data,
  setDropDownSelection,
  placeholder = "Select",
  defaultSelected = null,
  isDisabled,
  dataTrackingId
}: IProps) => {
  const [isShowItems, setIsShowItems] = useState<boolean>(false);
  const dropDownRef = useRef<HTMLDivElement>(null);

  const handleShowList = (event: any) => {
    event.preventDefault();
    setIsShowItems(!isShowItems);
  };

  const handleItemClick = (item: string, index: number) => {
    setDropDownSelection && setDropDownSelection({ [index]: item });
    setIsShowItems(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropDownRef.current &&
      !dropDownRef.current.contains(event.target as Node)
    ) {
      setIsShowItems(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropDownRef}
      className={classNames("drop-down-wrapper", "drop-down", {
        [`${styles}`]: styles,
      })}
      data-tracking-id={dataTrackingId}
    >
      <div
        className={classNames("selected-item-wrapper")}
        onClick={isDisabled ? undefined : handleShowList}
      >
        <div className={classNames("selected-item")}>
          <p className="selected-item-p">
            {defaultSelected !== null
              ? typeof defaultSelected === "string"
                ? defaultSelected
                : defaultSelected && typeof defaultSelected === "object"
                  ? Object.values(defaultSelected)[0]
                  : placeholder
              : placeholder}
          </p>
        </div>

        <div
          className={classNames(
            "drop-down-icon",
            isShowItems && "drop-down-icon-hide"
          )}
        >
          <DropDownIcon />
        </div>
      </div>

      {isShowItems && (
        <div className={classNames("drop-down-item-wrapper")}>
          <div className="drop-down-item-list-container">
            {data?.map((item, index) => (
              <div
                key={index}
                className={classNames({
                  "drop-down-item": true,
                  "first-item": index === 0,
                  "last-item": data?.length === index + 1,
                  "only-item": data?.length === 1,
                })}
                onClick={() => handleItemClick(item, index)}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
